import { c as _c } from "react/compiler-runtime";
import { LoaderSpinner } from '@module/mdrt-org/shared/components/loader/loader-spinner/loader-spinner';
import { Loader as LoaderBase, type LoaderProps } from '@shared/ui-components/loader/loader';
import { withSpinnerLoaderComponent } from '@shared/ui-components/with-spinner-loader-component/with-spinner-loader-component';
export const Loader = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoaderSpinner />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = withSpinnerLoaderComponent(LoaderBase, {
      ...props,
      loaderSpinner: t0
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};